export const patientFieldsValidation = {
  patientId: {
    minLength: { value: 1, message: 'Patient ID is required' },
  },
  mrn: {
    pattern: {
      value: /^[A-Za-z0-9-]*$/,
      message: 'MRN should include only English or numbers',
    },
  },
};
